/**
 * Plain-text marker the backend appends to every generated reply body
 */
export const EMAIL_FOOTER_MARKER = 'Tento řádek prosím v budoucí komunikaci zachovejte';

export const addFooterMarkerLineBreak = (message: string): string =>
  message.replace(EMAIL_FOOTER_MARKER, `${EMAIL_FOOTER_MARKER}<br/>`);

const SENDER_NAME_PLACEHOLDER = /\(\s*(?:<strong>)?\s*JM(?:&Eacute;|É)NO\s*(?:<\/strong>)?\s*\)/g;
export const fillSenderName = (message: string, senderName?: string): string =>
  senderName ? message.replace(SENDER_NAME_PLACEHOLDER, senderName) : message;

export const changeMessageOrder = (message: string) => {
  const parts = message.split('<br/>');
  const emailPart = parts.find(part => part.includes('Kontaktní e-mail'));
  const datePart = parts.find(part => part.includes('Datum a čas'));

  if (emailPart === undefined || datePart === undefined)
    return message;

  parts.splice(parts.indexOf(emailPart), 1);
  parts.splice(parts.indexOf(datePart) + 1, 0, emailPart);
  
  return parts.join('<br/>');
};